export const ChevronIcon = () => (
  <svg className="chevron" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6 4l4 4-4 4" stroke="#8B8FA3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BackIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M11.25 4.5L6.75 9l4.5 4.5" stroke="#D4D7E1" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const RewardsEmptyIcon = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" aria-hidden="true">
    <circle cx="36" cy="36" r="23" stroke="#3A4056" strokeWidth="2.2" />
    <circle cx="36" cy="36" r="16" stroke="#4B5168" strokeWidth="1.6" strokeDasharray="2 4" />
    <path
      d="M36 28.5v15M40 31.8c-.9-1.1-2.3-1.8-4-1.8-2.2 0-4 1.3-4 3s1.8 2.6 4 3 4 1.4 4 3.1-1.8 3-4 3c-1.7 0-3.1-.7-4-1.8"
      stroke="#9CA2B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M58 20l1.4 3.1L62.6 24l-2.6 2 .7 3.4-2.7-1.8-2.7 1.8.7-3.4-2.6-2 3.2-.9L58 20z" fill="#5B6178" />
    <path d="M14.5 44.5l.9 2 2.1.3-1.6 1.4.4 2.2-1.8-1.1-1.8 1.1.4-2.2-1.6-1.4 2.1-.3.9-2z" fill="#454B61" />
  </svg>
);

export const ExternalLinkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M8.5 2H12v3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 2L6.5 7.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6 3H4.5C3.67 3 3 3.67 3 4.5v5c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5V8"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
